<script>
import {getStatusColor, getStatusText} from "@/services/mappers";

export default {
  name: "Status",
  props: {
    status: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
    },
  },
  computed: {
    statusText() {
      return getStatusText(this.status)
    },
    statusColor() {
      return getStatusColor(this.status)
    },
  },
}
</script>

<template>
  <v-chip
    :color="statusColor"
    :text-color="statusColor === '' ? 'black' : 'white'"
    :small="small"
    v-on="$listeners"
  >
    {{ statusText }}
  </v-chip>
</template>